import { createContext } from 'react'

export type IngredientsCardMainElementContextType = boolean

const IngredientsCardMainElementContext =
  createContext<IngredientsCardMainElementContextType>(false)

export default IngredientsCardMainElementContext
